export default __webpack_public_path__ + "static/media/check-circle.45c3ad84.svg";